import { getBracketColor, BRACKET_HEX } from '../../utils/colors'
import i18n, { useLanguageTick } from '../../i18n'
import { formatBracket } from '../../utils/formatters'

interface BracketBadgeProps {
  bracket: number
  size?: 'sm' | 'lg'
}

// In the entry chunk (the home page), so its text is in the bundled `common`
// catalog, never the lazily shipped `bracket` one.
export default function BracketBadge({ bracket, size = 'lg' }: BracketBadgeProps) {
  useLanguageTick()
  const colors = getBracketColor(bracket)
  const hex = BRACKET_HEX[bracket]

  if (size === 'sm') {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold ${colors.bg} text-white`}>
        {i18n.t('common:bracket_short', { n: bracket })}
      </span>
    )
  }

  return (
    <div
      className="flex flex-col items-center justify-center gap-1.5 rounded-2xl"
      style={{
        width: 132,
        height: 132,
        backgroundColor: '#111827',
        border: `2px solid ${hex}`,
        boxShadow: `0 0 0 1px ${hex}33 inset, 0 8px 24px ${hex}80, 0 2px 6px ${hex}55`,
      }}
    >
      <span className="text-[56px] leading-none font-bold text-white"
        style={{ fontFamily: 'ui-rounded, "SF Pro Rounded", system-ui, sans-serif' }}
      >
        {bracket}
      </span>
      <span
        className="text-[13px] font-bold uppercase"
        style={{ color: hex, letterSpacing: '0.18em' }}
      >
        {formatBracket(bracket)}
      </span>
    </div>
  )
}
